import axios from "axios";
import { ApiPathRESE } from "../../../common/api-path/ApiPath";

export default class RESECommandService {
	async getDivisionDetail() {
		const response = await axios.get(
			`${ApiPathRESE.baseUrl}/windows-service/inventorydetails`,
			{ timeout: 120000, timeoutErrorMessage: "request timeout" }
		);
		if (response.status >= 400) {
			throw new Error(response.errors);
		}
		return response.data.data;
	}

	async resepostCreateJob(job) {
		const response = await axios.post(
			`${ApiPathRESE.baseUrl}/windows-service/job`,
			job,
			{ timeout: 120000, timeoutErrorMessage: "request timeout" }
		);
		if (response.status >= 400) {
			throw new Error(response.errors);
		}
		return response.data.data;
	}

	async getJobDetails(startDate, endDate, offset) {
		const requestConfig = {
			params: { startDate, endDate, offset },
			timeout: 120000,
			timeoutErrorMessage: "request timeout",
		};
		const response = await axios.get(
			`${ApiPathRESE.baseUrl}/windows-service/jobdetail`,
			requestConfig
		);
		if (response.status >= 400) {
			throw new Error(response.errors);
		}
		return response.data.data;
	}

	async getServerDetailsById(id) {
		const requestConfig = {
			params: { jobId: id },
			timeout: 120000,
			timeoutErrorMessage: "request timeout",
		};
		const response = await axios.get(
			`${ApiPathRESE.baseUrl}/windows-service/job`,
			requestConfig
		);
		if (response.status >= 400) {
			throw new Error(response.errors);
		}
		return response.data.data;
	}

	async cancelJobSchedule(cancelSchedule) {
		console.log("cancelSchedule", cancelSchedule);
		const response = await axios.delete(
			`${ApiPathRESE.baseUrl}/windows-service/job/${cancelSchedule}`,
			{ timeout: 120000, timeoutErrorMessage: "request timeout" }
		);
		if (response.status >= 400) {
			throw new Error(response.errors);
		}
		return response.data.data;
	}
}
